module.exports = __webpack_public_path__ + "img/SSP.478733a7.png";